import { render, staticRenderFns } from "./edit-registrationdialog.vue?vue&type=template&id=20f3b3f0&scoped=true"
import script from "./edit-registrationdialog.vue?vue&type=script&lang=ts"
export * from "./edit-registrationdialog.vue?vue&type=script&lang=ts"
import style0 from "./edit-registrationdialog.vue?vue&type=style&index=0&id=20f3b3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3b3f0",
  null
  
)

export default component.exports